// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__uwbj3","phonePrefix":"styles_phonePrefix__cAgox"};